import styled from 'styled-components'
import theme from '../theme'

export default styled.div`
  margin-top: 0.5rem;
  display: block;
  h2 {
    font-size: 1.4rem;
    font-family: ${theme.font.main};
  }
`;
